/**
 * Step label text — the single source of the phrase for each `STEP_KIND`.
 *
 * Extracted from `components/Steps/strategies/stepHeadingRegistry.ts` because TWO
 * layers need the same words. The table holds TRANSLATION KEYS, not display text:
 * the store and the domains run outside React, so `t()` is applied at the render
 * site ([ChatStep](../components/Steps/ChatStep.tsx)).
 */

import { STEP_KIND } from 'src/content/ChatV2/types/steps';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

/** `Record` (not `Map`) so adding a `STEP_KIND` member is a compile error here. */
export const STEP_KIND_LABEL: Record<STEP_KIND, string> = {
  [STEP_KIND.SEARCHING_WORKSPACE]: T.searchingTheWorkspaces,
  [STEP_KIND.LISTING_DOCUMENTS]: T.listingRelevantDocuments,
  [STEP_KIND.SEARCHING_WEB]: T.searchingTheWeb,
  [STEP_KIND.RUNNING_SCRIPT]: T.runningAScript,
  [STEP_KIND.EXECUTING_CODE]: T.executingTheCode,
  [STEP_KIND.CHECKING_IMAGE]: T.generatingImage,
  [STEP_KIND.DEEP_RESEARCH]: T.deepResearch,
  [STEP_KIND.CALLING_SUB_AGENT]: T.callingASubAgent,
  [STEP_KIND.CHECKING_FILES]: T.checkingFiles,
  [STEP_KIND.TOOL_SEARCH]: T.toolSearch,
  [STEP_KIND.INTERRUPT]: T.waitingForConfirmation,
  [STEP_KIND.DONE]: T.done,
  [STEP_KIND.FAILED]: T.failedDoingAction
};

/** Shown when a kind somehow isn't in the table (defensive; the Record prevents it). */
export const FALLBACK_STEP_LABEL = T.working;

/**
 * `Searching the web "current weather in Lahore"` — the phrase plus the tool's own
 * input, in full. Clipping is left to the heading's CSS, which shows the whole
 * query once the step is expanded.
 */
export function labelWithQuery(base: string, query?: unknown): string {
  if (typeof query !== 'string') {
    return base;
  }
  const trimmed = query.trim();
  if (trimmed === '') {
    return base;
  }
  return `${base} "${trimmed}"`;
}
